import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
import { Modal } from "@cxagroup/casper";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const MessageConfirmDialog = props => {
  const { isOpen, messageTitle, messageContent, close } = props;
  return (
    <Modal isOpen={isOpen} onRequestClose={close} contentLabel="Message Confirm">
      <div>
        <h2>{messageTitle}</h2>
      </div>
      <div className="modal__body">
        <p>{messageContent}</p>
      </div>
      <div className="modal__footer">
        <Button type="button" secondary onClick={close}>
          <FormattedMessage {...messages.okTextDescription} />
        </Button>
      </div>
    </Modal>
  );
};

MessageConfirmDialog.propTypes = {
  messageTitle: PropTypes.string,
  messageContent: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  eventHandler: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(MessageConfirmDialog);



// WEBPACK FOOTER //
// ./components/inAppMessages/MessageConfirmDialog.js